import React, { ReactNode } from "react";
import BasketIcon from "@/app/assets/images/svg/basket.svg";
import Arrow from "@/app/assets/images/svg/chevron.svg";
import AccountIcon from "@/app/assets/images/svg/user.svg";
import clsx from "clsx";
import Link from "next/link";
import styles from "./NavItem.module.scss";

interface navItemProps {
	text: string;
	isActive: boolean;
	tabIndex?: boolean | undefined;
	staticLinkType?: "Account" | "Cart";
	isTopLevel?: boolean;
	mobileOnly?: boolean;
	link?: string;
	children?: ReactNode[];
	handleMenuClick?: () => void;
	handleCloseClick: () => void;
	ariaHidden: boolean;
}

const NavItem = ({
	text = "",
	isActive,
	staticLinkType,
	tabIndex = true,
	isTopLevel = false,
	mobileOnly = false,
	link = "#",
	children = [],
	handleMenuClick,
	handleCloseClick,
	...props
}: navItemProps) => {
	const { ariaHidden, ...rest } = props;

	// const activeState = activeEntityIds?.some((id) => id === entityId);
	// console.log(`ACTIVE: ${activeState}`);

	// Generate a link for a page if its the final child
	if (children.length === 0) {
		return (
			<Link
				href={link}
				className={clsx([
					styles.item,
					isTopLevel ? styles.topLevel : "",
					mobileOnly ? styles.mobileOnly : "",
					staticLinkType ? styles.staticLink : "",
				])}
				tabIndex={tabIndex ? 1 : -1}
				aria-hidden={ariaHidden}
				onClick={() => handleCloseClick()}
				{...rest}
			>
				{staticLinkType && getStaticLinkIcon(staticLinkType)}
				{text}
			</Link>
		);
	}

	// Generate a button element that will handle the click event passed to it
	return (
		<button
			type='button'
			className={clsx([
				styles.item,
				isTopLevel ? styles.topLevel : "",
				isActive ? styles.active : "",
				mobileOnly ? styles.mobileOnly : "",
			])}
			onClick={handleMenuClick}
			aria-hidden={ariaHidden}
			{...rest}
			tabIndex={tabIndex ? 1 : -1}
		>
			<div className={styles.text}>{text}</div>
			<Arrow className={styles.arrow} aria-labelledby='directional chevron' />
		</button>
	);
};

export default NavItem;

const getStaticLinkIcon = (type: string) => {
	switch (type) {
		case "Account":
			return <AccountIcon />;
		case "Cart":
			return <BasketIcon />;
		default:
			return null;
	}
};
